<template>
    <div class="container">
        <div class="row input-container select-button-container">
            <div
                class="col-lg-6 button-wrapper"
                :class="[
                    ((optionIndex % 2 == 0 && options.length - 1 == optionIndex) || options.length == 1) &&
                        'offset-lg-3',
                    mobileFullWidth ? 'col-12' : 'col-6',
                ]"
                :key="optionIndex"
                v-for="(option, optionIndex) in options"
            >
                <button
                    class="btn button select-button"
                    :class="[
                        option.logo && option.logo.image_url && 'text-left has-logo',
                        ((multiple && value && value.length && value.includes(option.value)) ||
                            (!multiple && value == option.value)) &&
                            'active',
                        buttonClasses,
                    ]"
                    @click.prevent="select(option)"
                >
                    <div v-if="option.logo && option.logo.image_url" class="select-button-logo">
                        <img :src="option.logo.image_url" :alt="option.logo.title" />
                    </div>
                    {{ option.name }}
                </button>
            </div>
        </div>

        <Field type="hidden" :name="name" v-model="value" />
        <div class="error" v-if="displayErrorMessage">{{ displayErrorMessage }}</div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useField, Field } from 'vee-validate'
import { titleCase } from '@js/utilities/language.js'

// lodash components
import filter from 'lodash/filter'
import _get from 'lodash/get'

export default {
    components: {
        Field,
    },
    props: {
        options: {
            default: () => {},
        },
        customErrorMessage: String,
        label: String,
        multiple: Boolean,
        name: String,
        selected: Function,
        validationRules: Object,
        vuexKey: String,
        mobileFullWidth: Boolean,
        buttonClasses: String,
    },
    setup(props) {
        const store = useStore()
        const { resetField, errorMessage, handleChange, validate } = useField(props.name, props.validationRules, {
            label: titleCase(props.name),
        })

        return {
            resetField,
            errorMessage,
            handleChange,
            validate,
            store,
        }
    },
    mounted() {
        if (this.value) {
            this.$nextTick(() => {
                this.resetField({
                    value: this.value,
                })
                this.validate()
            })
        }
    },
    computed: {
        value: {
            get() {
                const value = this.store.getters.fieldValue(this.name, this.vuexKey || 'data', !!this.vuexKey)

                if (value) {
                    this.$nextTick(() => {
                        this.resetField({
                            value: value,
                        })
                    })
                }

                return value
            },
            set(value) {
                if (this.vuexKey) {
                    this.store.commit('setDataFieldValue', {
                        name: this.name,
                        value: value,
                        key: this.vuexKey,
                    })
                } else {
                    this.store.dispatch('setFieldValue', {
                        name: this.name,
                        value: value,
                    })
                }

                if (value) {
                    this.handleChange(value)
                }

                this.$emit('input', {
                    name: this.name,
                    value: value,
                })
            },
        },
        serverError() {
            return this.store.getters.fieldServerError(this.name)
        },
        displayErrorMessage() {
            return this.errorMessage ? this.customErrorMessage || this.errorMessage : this.serverError
        },
    },
    methods: {
        select: function (option) {
            if (this.multiple) {
                if (!this.value) {
                    this.value = []
                }

                if (this.value.length && this.value.includes(option.value)) {
                    this.value = filter(this.value, function (item) {
                        return item !== option.value
                    })
                } else {
                    this.value.push(option.value)
                }
            } else {
                this.value = option.value
            }

            if (this.selected) {
                this.selected(this.value)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.input-container {
    &.select-button-container {
        .button-wrapper {
            padding-right: 0px;
            padding-left: 0px;
            padding-bottom: 7px;

            &:nth-child(even) {
                padding-right: 0px;
                padding-left: 7px;
            }
        }
        .select-button {
            font-family: var(--heading-font);
            font-size: 15px;
            font-weight: bold;
            height: 52px;
            line-height: 15px;
            text-align: center;
            width: 100%;

            &.has-logo {
                display: flex;
                align-items: center;

                .select-button-logo {
                    background-color: #ffffff;
                    border-radius: 50%;
                    min-height: 35px;
                    max-height: 35px;
                    min-width: 35px;
                    max-width: 35px;
                    margin-right: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;

                    img {
                        max-width: 70%;
                    }
                }
            }
        }
    }
}
.error {
    color: #ff0000;
    font-size: rem(11px);
    padding: 5px 5px 5px 22px;
    position: relative;

    .icon {
        font-size: rem(14px);
        left: 2px;
        position: absolute;
        top: 6px;
    }
}
</style>
